<template>
    <div>
        <div>
            <strong class="text-green font-bold">
                Informations personnelles</strong
            >
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label>Nom</label>
                    <input
                        type="text"
                        v-model="form.lastname"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.lastname,
                        }"
                    />
                </div>
                <div>
                    <label>Prénom</label>
                    <input
                        type="text"
                        v-model="form.firstname"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.firstname,
                        }"
                    />
                </div>
                <div>
                    <label>Email</label>
                    <input
                        type="email"
                        v-model="form.email"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.email,
                        }"
                    />
                </div>
                <div>
                    <label>Numéro</label>
                    <input
                        type="tel"
                        v-model="form.phone"
                        :class="{
                            inputIsInvalid: apiStore.$state.errors.phone,
                        }"
                    />
                </div>
            </div>
            <strong class="text-green font-bold"> Votre employeur</strong>
            <div>
                <label for="companyName">Nom de l'entreprise</label>
                <input
                    type="text"
                    v-model="form.companyName"
                    id="companyName"
                />
            </div>
        </div>

        <div class="w-full text-center">
            <button
                @click="submitForm"
                class="bg-green text-white px-4 py-2 rounded"
            >
                Soumettre
            </button>
        </div>
    </div>
</template>

<script setup>
import { useApiStore } from '@/js/stores/apiStore';
import { reactive } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const $router = useRouter();

const route = useRoute();
const apiStore = useApiStore();

const form = reactive({
    name: '',
    firstname: '',
    email: '',
    phone: '',
    message:
        'Client intéressé par un plan vélo et il regardait le vélo suivant :' +
        route.params.id,
});

const submitForm = () => {
    apiStore
        .apiPost('/api/emails/contact', form)
        .then(() => {
            $router.push({
                name: 'thank-you-for-the-bike-plan-request',
            });
        })
        .catch(() => {});
};
</script>
